export default __webpack_public_path__ + "static/media/Thorin's Letter to Bilbo_06.3b3563b7.jpg";